import img1 from '../../images/AdvantagesConvenience.png';
import { ReactComponent as Icon1 } from '../../images/CustomerFocus/ic_baseline-telegram.svg';
import { ReactComponent as Icon2 } from '../../images/CustomerFocus/ic_baseline-telegram2.svg';
import { ReactComponent as Icon3 } from '../../images/CustomerFocus/ic_baseline-telegram3.svg';
import { ReactComponent as Icon4 } from '../../images/CustomerFocus/ic_baseline-telegram4.svg';
import { ReactComponent as Icon5 } from '../../images/CustomerFocus/database.svg';
import { ReactComponent as Icon6 } from '../../images/CustomerFocus/webhook.svg';

export const CUSTOMERFOCUS = {
  title: 'Клиентоориентированность',
  items: [
    {
      id: 1,
      icon: Icon1,
      title: 'Гибкая цена',
      description: 'Платите только за активные скважины, по которым поступают данные',
    },
    // {
    //   id: 10,
    //   img: img1,
    // },
    {
      id: 2,
      icon: Icon2,
      title: 'Адаптируемость',
      description: 'Возможность доработки системы под индивидуальные требования',
    },
    // {
    //   id: 20,
    //   img: img1,
    // },
    // {
    //   id: 30,
    //   img: img1,
    // },
    {
      id: 3,
      icon: Icon3,
      title: 'Возможность тестирования',
      description: 'Пробную версию можно развернуть как в облаке, так и на собственном сервере',
    },
    // {
    //   id: 40,
    //   img: img1,
    // },
    {
      id: 4,
      icon: Icon4,
      title: 'Профессионализм',
      description: 'Наши специалисты ответят на все вопросы',
    },
    {
      id: 5,
      icon: Icon5,
      title: 'Размещение у Заказчика',
      description: 'Возможность разместить Web-портал и хранить данных на серверах Заказчика',
    },
    {
      id: 6,
      icon: Icon6,
      title: 'Интеграция',
      description: 'Интеграция с ERP системами (например 1С), а также с программами Заказчика посредством API',
    },
  ],
};
